import Controller from '@ember/controller';

export default class PaypalFailureController extends Controller {
  queryParams = ['transactionId'];
}
